module.exports = __webpack_public_path__ + "img/bbdc-tablet-and-mobile.7c4c1025.jpg";